import APIClient from '@/shared/http/clients/api'

const resourceName = 'empresalogo'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

// ZC-89: sobe o logo pro bucket static.zopone.com.br e devolve a chave (vai em empresa.logo no PUT da empresa).
const Upload = (codigoZ, arquivo, config = {}) => {
  const formData = new FormData()
  formData.append('arquivo', arquivo)
  return APIClient.post(`${APIBusinessCommon}/${resourceName}/${codigoZ}`, formData, config)
}

const CompanyLogoRepository = {
  Upload
}

export default CompanyLogoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/companylogo.js